<template>
  <div>
    <div class="headersmo">
      <div class="top-box-difl">
        <div class="divimg">
          <img src="../assets/img/logo@2x.png" alt="" />
        </div>

        <div class="top-leir">
          <el-dropdown trigger="click" @command="changeLang">
            <span class="el-dropdown-link">
              <div class="leif-cn">
                <img src="../assets/img/cn.png" alt="" />
                <span>{{ $t("names") }}</span>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="en">English(EN)</el-dropdown-item>
              <el-dropdown-item command="zh">中文(CN)</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},
  methods: {
    changeLang(lang) {
      let targetLang = lang;
      this.$i18n.locale = targetLang;
      localStorage.setItem("lang", targetLang);
    },
  },
};
</script>

<style lang="scss" scoped>
// 引入外部移动端样式文件
@import "@/assets/style/headersmo.scss";
</style>